import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm";
import { useParams } from "react-router-dom";
import DownloadExcel, {
  formatNumber,
  getRecords,
} from "../../../services/api.service";
import { Warehouse } from "lucide-react";

const CategoryWiseStocks = () => {
  const { id } = useParams;
  const [searchKeyword, setSearchKeyword] = useState("");
  const [expandedCategories, setExpandedCategories] = useState({});
  const [loadingData, setLoadingData] = useState(false);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;
  const [typeCostQTY, setTypeCostQTY] = useState(null);
  const [itemsData, setItemsData] = useState({});
  const [csvData, setCsvData] = useState([]);
  useEffect(() => {
    fetchReports(); // Fetch initial data
    fetchCSVReports();

    // Event Listener for localStorage changes
    const handleStorageChange = () => {
      fetchReports();
      fetchCSVReports();
    };

    // Listen for the custom event
    window.addEventListener("dashboardUpdate", handleStorageChange);

    return () => {
      window.removeEventListener("dashboardUpdate", handleStorageChange);
    };
  }, []);

  const filteredItems =
    data.filter((row) =>
      row?.project_name?.toLowerCase().includes(searchKeyword.toLowerCase())
    ) || [];
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredItems.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.ceil(filteredItems.length / recordsPerPage);
  const fetchCSVReports = async (Id) => {
    try {
      const dashboard_details = localStorage.getItem("dashboard_details");
      if (!dashboard_details) return;

      const payload = JSON.parse(dashboard_details);
      setTypeCostQTY(payload.type);
      let responseData = await getRecords(
        payload,
        "/dashboard/categoryWiseAvailableStock"
      );
      if (responseData.code == 1 && responseData.data.length > 0) {
        setCsvData(responseData.data);
        setLoadingData(false);
      } else {
        setCsvData([]);
        setLoadingData(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchReports = async (Id) => {
    try {
      setLoadingData(true);
      const dashboard_details = localStorage.getItem("dashboard_details");
      if (!dashboard_details) return;

      const payload = JSON.parse(dashboard_details);
      setTypeCostQTY(payload.type);
      let responseData = await getRecords(
        payload,
        "/dashboard/categoryWiseAvailableStockSummary"
      );
      if (responseData.code == 1 && responseData.data.length > 0) {
        setData(responseData.data);
        setLoadingData(false);
      } else {
        setData([]);
        setLoadingData(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchKeyword(value);
    setCurrentPage(1);
  };

  const toggleCategory = async (index, row) => {
    try {
      const payload = {
        project_id: row.project_id,
        warehouse_id: row.warehouse_id,
        category_id: row.category_id,
      };
      let responseData = await getRecords(
        payload,
        "/dashboard/categoryWiseAvailableStockDetails"
      );

      if (responseData.code == 1 && responseData.data.length > 0) {
        setItemsData((prev) => ({
          ...prev,
          [index]: responseData.code == 1 ? responseData.data : [],
        }));
        setLoadingData(false);
      } else {
        setItemsData((prev) => ({
          ...prev,
          [index]: [],
        }));
        setLoadingData(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setExpandedCategories((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleExportData = () => {
    const { columns, rows } = generateCSVData();

    DownloadExcel({
      fileName: "CategoryWiseStocks",
      columns: columns,
      data: rows,
      cellColor: false,
    });
  };

  const generateCSVData = () => {
    const columns = [
      { label: "Sr No", key: "srNo" },
      { label: "Project Name", key: "project_name" },
      { label: "Warehouse Type", key: "warehouse_type" },
      { label: "Warehouse Name", key: "warehouse_name" },
      { label: "Category", key: "category_name" },
      {
        label: `Stock  ${typeCostQTY == "cost" ? "Cost" : "Qty"}`,
        key: "stock_qty",
      },
      {
        label: `Provision  ${typeCostQTY == "cost" ? "Cost" : "Qty"}`,
        key: "provision_qty",
      },
      {
        label: `Shortage ${typeCostQTY == "cost" ? "Cost" : "Qty"}`,
        key: "shortage_qty",
      },
      {
        label: `MRB ${typeCostQTY == "cost" ? "Cost" : "Qty"}`,
        key: "mrb_qty",
      },
      {
        label: `Scrap  ${typeCostQTY == "cost" ? "Cost" : "Qty"}`,
        key: "scrab_qty",
      },
    ];

    const rows = [];

    csvData?.forEach((project, pIndex) => {
      if (pIndex !== 0) {
        // Empty Row Before New Project
        rows.push({
          srNo: "",
          project_name: "",
          warehouse_type: "",
          warehouse_name: "",
          category: "",
          stock_qty: "",
          provision_qty: "",
          shortage_qty: "",
          mrb_qty: "",
          scrab_qty: "",
        });
      }
      rows.push({
        srNo: pIndex + 1,
        project_name: project?.project_name || "N/A",
        warehouse_type:
          project?.warehouse_type == 1 ? "Bermad" : "Contractor" || "N/A",
        warehouse_name: project?.warehouse_name || "N/A",
        category_name: project?.category_name || "N/A",
        stock_qty:
          typeCostQTY === "cost"
            ? project?.stock_qty_cost || "0"
            : project?.stock_qty || "0",
        provision_qty:
          typeCostQTY === "cost"
            ? project?.provision_qty_cost || "0"
            : project?.provision_qty || "0",
        shortage_qty:
          typeCostQTY === "cost"
            ? project?.shortage_qty_cost || "0"
            : project?.shortage_qty || "0",
        mrb_qty:
          typeCostQTY === "cost"
            ? project?.mrb_qty_cost || "0"
            : project?.mrb_qty || "0",
        scrab_qty:
          typeCostQTY === "cost"
            ? project?.scrab_qty_cost || "0"
            : project?.scrab_qty || "0",
      });

      rows.push({
        srNo: "",
        project_name: "Sr No",
        warehouse_type: "Item Code",
        warehouse_name: "Item Description",
        category_name: `Stock ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
        stock_qty: `Provision ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
        provision_qty: `Shortage ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
        shortage_qty: `MRB ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
        mrb_qty: `Scrap ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
        scrab_qty: "",
        isHeader: true,
      });

      project?.items?.forEach((item, iIndex) => {
        rows.push({
          project_name: iIndex + 1,
          warehouse_type: item?.item_code || "N/A",
          warehouse_name: item?.description || "N/A",
          category_name:
            item?.type === 1
              ? "-"
              : typeCostQTY === "cost"
              ? item?.stock_qty_cost || "0"
              : item?.stock_qty || "0",
          stock_qty:
            item?.type === 1
              ? "-"
              : typeCostQTY === "cost"
              ? item?.provision_qty_cost || "0"
              : item?.provision_qty || "0",
          provision_qty:
            item?.type === 1
              ? "-"
              : typeCostQTY === "cost"
              ? item?.shortage_qty_cost || "0"
              : item?.shortage_qty || "0",
          shortage_qty:
            item?.type === 1
              ? "-"
              : typeCostQTY === "cost"
              ? item?.mrb_qty_cost || "0"
              : item?.mrb_qty || "0",
          mrb_qty:
            item?.type === 1
              ? "-"
              : typeCostQTY === "cost"
              ? item?.scrap_qty_cost || "0"
              : item?.scrab_qty || "0",
        });

        if (item?.type === 1 && item?.buy_items) {
          item?.buy_items?.forEach((buyItem, bIndex) => {
            rows.push({
              project_name: `${iIndex + 1}.${bIndex + 1}`,
              warehouse_type: buyItem?.item_code || "N/A",
              warehouse_name: buyItem?.description || "N/A",
              category_name:
                typeCostQTY === "cost"
                  ? buyItem?.stock_qty_cost || "0"
                  : buyItem?.stock_qty || "0",
              stock_qty:
                typeCostQTY === "cost"
                  ? buyItem?.provision_qty_cost || "0"
                  : buyItem?.provision_qty || "0",
              provision_qty:
                typeCostQTY === "cost"
                  ? buyItem?.shortage_qty_cost || "0"
                  : buyItem?.shortage_qty || "0",
              shortage_qty:
                typeCostQTY === "cost"
                  ? buyItem?.mrb_qty_cost || "0"
                  : buyItem?.mrb_qty || "0",
              mrb_qty:
                typeCostQTY === "cost"
                  ? buyItem?.scrap_qty_cost || "0"
                  : buyItem?.scrab_qty || "0",
            });
          });
        }
      });
    });

    return { columns, rows };
  };

  return (
    <CustomForm
      title={"CATEGORY WISE STOCKS"}
      id={id}
      loadingData={loadingData}
      noBackButton={true}
      noSubmitButton={true}
    >
      <Row className="mt-1">
        <Col lg={12}>
          <div className="">
            <div className="mb-2 d-flex justify-content-between align-items-center text-white">
              <div>
                <div className="app-search d-flex d-lg-inline mt-0 w-25">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control ps-5"
                      placeholder="Search by project name.."
                      value={searchKeyword}
                      onChange={handleInputChange}
                      style={{
                        width: "15rem",
                        padding: "8px 15px",
                        borderRadius: "8px",
                        borderColor: "#D2D2D2",
                        outline: "none",
                        transition: "all 0.3s ease",
                        boxShadow: "none",
                        marginRight: "0.5rem",
                      }}
                    />
                    <span className="ri-search-line"></span>
                  </div>
                </div>
              </div>
              <div>
                <div onClick={handleExportData} className="btn btn-success">
                  Download CSV
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div
                className=""
                style={{
                  overflowX: "auto",
                  overflowY: "auto",
                  width: "100%",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "thin",
                  msOverflowStyle: "none",
                  zIndex: 0,
                  maxHeight: "500px",
                }}
              >
                <table
                  className="table mb-0"
                  style={{
                    border: "1px solid black",
                  }}
                >
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      backgroundColor: "#8AC1E8",
                      borderBottom: "1px solid #cccccc",
                    }}
                  >
                    <tr>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Sr. No
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Project Name
                      </th>

                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Warehouse Type
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Warehouse Name
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          width: "122%",
                        }}
                      >
                        Category
                      </th>

                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Stock {typeCostQTY == "cost" ? "Cost" : "Qty"}
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Provision {typeCostQTY == "cost" ? "Cost" : "Qty"}
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Shortage {typeCostQTY == "cost" ? "Cost" : "Qty"}
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        MRB {typeCostQTY == "cost" ? "Cost" : "Qty"}
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        Scrap {typeCostQTY == "cost" ? "Cost" : "Qty"}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords?.length > 0 ? (
                      currentRecords.map((row, index) => (
                        <React.Fragment key={index}>
                          <tr
                            style={{
                              verticalAlign: "middle",
                            }}
                            onClick={() => toggleCategory(index, row)}
                          >
                            <td>{indexOfFirstRecord + index + 1}</td>
                            <td
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "2px",
                                minWidth: "180px",
                              }}
                            >
                              <div
                                style={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  WebkitLineClamp: 2,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  overflowWrap: "break-word",
                                }}
                                title={row?.project_name || "N/A"}
                              >
                                {row?.project_name || "N/A"}
                              </div>
                            </td>
                            <td>
                              {row?.warehouse_type == 1
                                ? "Bermad"
                                : "Contractor" || "N/A"}
                            </td>
                            <td>{row?.warehouse_name || "N/A"}</td>
                            <td
                              style={{
                                width: "150px",
                                minWidth: "150px",
                                maxWidth: "150px",
                              }}
                            >
                              {row?.category_name || "N/A"}{" "}
                              <i
                                className={`mdi mdi-chevron-${
                                  expandedCategories[index] ? "up" : "down"
                                } font-size-18`}
                              ></i>
                            </td>

                            <td>
                              {typeCostQTY == "cost"
                                ? formatNumber(row?.stock_qty_cost)
                                : formatNumber(row?.stock_qty) || "0"}
                            </td>

                            <td>
                              {typeCostQTY == "cost"
                                ? formatNumber(row?.provision_qty_cost)
                                : formatNumber(row?.provision_qty) || "0"}
                            </td>

                            <td>
                              {typeCostQTY == "cost"
                                ? formatNumber(row?.shortage_qty_cost)
                                : formatNumber(row?.shortage_qty) || "0"}
                            </td>
                            <td>
                              {typeCostQTY == "cost"
                                ? formatNumber(row?.mrb_qty_cost)
                                : formatNumber(row?.mrb_qty) || "0"}
                            </td>
                            <td>
                              {typeCostQTY == "cost"
                                ? formatNumber(row?.scrab_qty_cost)
                                : formatNumber(row?.scrab_qty) || "0"}
                            </td>
                          </tr>
                          {expandedCategories[index] && itemsData[index] && (
                            <>
                              <tr
                                style={{
                                  backgroundColor: "#E5F1FC",

                                  borderBottom: "1px solid #cccccc",
                                  position: "sticky",
                                  top: 0,
                                }}
                              >
                                <th></th>

                                <th style={{ whiteSpace: "nowrap" }}>Sr No</th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Item Code
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Item Description
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Stock {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Provision{" "}
                                  {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Shortage{" "}
                                  {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  MRB {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Scrap {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}></th>
                              </tr>
                              {itemsData[index]?.map((item, iIndex) => (
                                <React.Fragment key={iIndex}>
                                  <tr
                                    style={{
                                      backgroundColor: "#f2f2f2",
                                    }}
                                  >
                                    <td></td>
                                    <td>{iIndex + 1}</td>
                                    <td>{item.item_code}</td>
                                    <td>
                                      <div
                                        style={{
                                          display: "-webkit-box",
                                          WebkitBoxOrient: "vertical",
                                          WebkitLineClamp: 2,
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "normal",
                                        }}
                                        title={item.description || "N/A"}
                                      >
                                        {item.description || "N/A"}
                                      </div>
                                    </td>
                                    <td>
                                      {item.type == 1
                                        ? "-"
                                        : typeCostQTY == "cost"
                                        ? formatNumber(item.stock_qty_cost)
                                        : formatNumber(item.stock_qty || "0")}
                                    </td>
                                    <td>
                                      {item.type == 1
                                        ? "-"
                                        : typeCostQTY == "cost"
                                        ? formatNumber(item.provision_qty_cost)
                                        : formatNumber(
                                            item.provision_qty || "0"
                                          )}
                                    </td>
                                    <td>
                                      {item.type == 1
                                        ? "-"
                                        : typeCostQTY == "cost"
                                        ? formatNumber(item.shortage_qty_cost)
                                        : formatNumber(
                                            item.shortage_qty || "0"
                                          )}
                                    </td>
                                    <td>
                                      {item.type == 1
                                        ? "-"
                                        : typeCostQTY == "cost"
                                        ? formatNumber(item.mrb_qty_cost)
                                        : formatNumber(item.mrb_qty || "0")}
                                    </td>
                                    <td>
                                      {item.type == 1
                                        ? "-"
                                        : typeCostQTY == "cost"
                                        ? formatNumber(item.scrab_qty_cost)
                                        : formatNumber(item.scrab_qty || "0")}
                                    </td>
                                    <td></td>
                                  </tr>

                                  {item.buy_items &&
                                    item.type === 1 &&
                                    item.buy_items.map((buyItem, buyIndex) => (
                                      <tr
                                        key={buyIndex}
                                        style={{
                                          backgroundColor: "#f2f2f2",
                                        }}
                                      >
                                        <td></td>
                                        <td
                                          style={{
                                            paddingLeft: "30px",
                                          }}
                                        >{`${iIndex + 1}.${buyIndex + 1}`}</td>
                                        <td>{buyItem.item_code}</td>
                                        <td>
                                          <div
                                            style={{
                                              display: "-webkit-box",
                                              WebkitBoxOrient: "vertical",
                                              WebkitLineClamp: 2,
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "normal",
                                            }}
                                            title={buyItem.description || "N/A"}
                                          >
                                            {buyItem.description || "N/A"}
                                          </div>
                                        </td>
                                        <td>
                                          {formatNumber(
                                            buyItem?.stock_qty || "0"
                                          )}
                                        </td>
                                        <td>
                                          {formatNumber(
                                            buyItem?.provision_qty || "0"
                                          )}
                                        </td>
                                        <td>
                                          {formatNumber(
                                            buyItem?.shortage_qty || "0"
                                          )}
                                        </td>
                                        <td>
                                          {formatNumber(
                                            buyItem?.mrb_qty || "0"
                                          )}
                                        </td>
                                        <td>
                                          {formatNumber(
                                            buyItem?.scrab_qty || "0"
                                          )}
                                        </td>
                                        <td></td>
                                      </tr>
                                    ))}
                                </React.Fragment>
                              ))}
                              {index !== currentRecords.length - 1 && (
                                <tr
                                  style={{
                                    position: "sticky",
                                    top: 0,
                                    backgroundColor: "#8AC1E8",
                                    borderBottom: "1px solid #cccccc",
                                  }}
                                >
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Sr. No
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Project Name
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Warehouse Type
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Warehouse Name
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "122%",
                                    }}
                                  >
                                    Category
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Stock{" "}
                                    {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Provision{" "}
                                    {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Shortage{" "}
                                    {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    MRB {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Scrap{" "}
                                    {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                  </th>
                                </tr>
                              )}
                            </>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center">
                          No data available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-primary"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  Previous
                </button>
                <span>
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  className="btn btn-primary"
                  disabled={currentPage === totalPages || totalPages === 0}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </CustomForm>
  );
};

export default CategoryWiseStocks;
